import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {
  IconButton,
} from "@material-ui/core";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");
import { message } from "constants/message";

const useStyles = makeStyles(() => ({
  datePicker: {
    width: "105px",
  },
  datePickerComplex: {
    width: "201px",
  },
}));

export default function MaterialUIPickers({ date, onChange, mediaFlag = false }) {
  const classes = useStyles();
  const messages = message();
  const minDate = mediaFlag ? dayjs().subtract(18, "month")
                            : dayjs().subtract(3, "month");
  const maxDate = dayjs();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container direction="row" alignItems="center" className={classes.datePickerComplex}>
        <Grid item>
          <IconButton
            color="primary"
            component="span"
            onClick={() => {
              onChange(dayjs(date).add(-1, "day").format("YYYY-MM-DD"));
            }}
            disabled={dayjs(minDate).isSame(dayjs(date), "date")}
          >
            <ArrowLeftIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <DatePicker
            margin="normal"
            format="yyyy/MM/dd"
            value={date}
            minDate={minDate}
            minDateMessage={
              (messages.validation.minDate).replace(
                "$1",
                minDate.format("YYYY-MM-DD")
              )
            }
            maxDate={maxDate}
            maxDateMessage={
              (messages.validation.maxDate).replace(
                "$1",
                maxDate.format("YYYY-MM-DD")
              )
            }
            onChange={(date) =>
              onChange(dayjs(date).format("YYYY-MM-DD"))
            }
            className={classes.datePicker}
          />
        </Grid>
        <Grid item>
          <IconButton
            color="primary"
            component="span"
            onClick={() => {
              onChange(dayjs(date).add(1, "day").format("YYYY-MM-DD"));
            }}
            disabled={dayjs(maxDate).isSame(dayjs(date), "date")}
          >
            <ArrowRightIcon />
          </IconButton>
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
